export default __webpack_public_path__ + "static/media/seattle.a6c71cf1.JPG";